import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { DepartmentAddEditComponent, DepartmentListComponent } from '@user/components/department';

const routes: Routes = [
  { path: 'list', component: DepartmentListComponent, canActivate: [AuthGuard], data: { title: 'Department' } }
];
@NgModule({
  declarations: [DepartmentAddEditComponent, DepartmentListComponent],
  imports: [
    RouterModule.forChild(routes),
    LayoutModule,
    MatDialogModule, MatIconModule, MatButtonModule,
    SharedModule,
  ],
  entryComponents: [DepartmentAddEditComponent]
})
export class DepartmentModule { }